import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  timezone: {
    main: {
      format: "Etc/GMT-8",
      name: {
        zh: "CST",
        ru: "CST",
      },
    },
    msk: {
      format: "Europe/Moscow",
      name: {
        zh: "MSK",
        ru: "МСК",
      },
    },
  },
  dates: {
    registrationStart: "",
    broadcastsStart: "2021-10-04T09:00:00+03:00",
    registrationEnd: "",
    networkingDays: [],
  },
  error: "",
};

export default function Event(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Event.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Event.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Event.CLEAR:
      return { ...state, ...InitialState };
    default:
      return state;
  }
}
